import { createAsyncThunk } from "@reduxjs/toolkit";
import TrackingUtils from "@tracking/utils/TrackingUtils";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getDetalheOcorrens = createAsyncThunk(
  "ediApp/transportadoras/getDetalheOcorrens",
  async (data: any, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/edi/pedidos-ocorrencias", {
        params: TrackingUtils.removeEmptyParams(data),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos. Caso estejam, solicite contato com a transportadora.",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);
